import React, { useEffect, useState, useMemo } from "react";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  useLocation,
  useHistory,
} from "react-router-dom";
import MainPage from "./Pages/MainPage";

import "bootstrap/dist/css/bootstrap.min.css";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import { useTranslation } from "react-i18next";

import "./i18n";
import Login from "./Pages/Login";

export const MyDomain = "http://localhost:3000/";

//for local
//export const MyDomain = "https://localhost:44326/";
//for cloud

const App = () => {
  const { i18n } = useTranslation();

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };
  const lang = JSON.parse(localStorage.getItem("lang")) ?? JSON.stringify("en");
  const location = useLocation();
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  const history = useHistory();

  useEffect(() => {
    changeLanguage(lang);
    const normalizedPath = window.location.pathname.toLowerCase();
    if (window.location.pathname !== normalizedPath) {
      history.replace(normalizedPath); // Redirect to lowercase URL
    }
  }, [history]);

  useEffect(() => {
    //handleClearSpecificItem();
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // const handleClearSpecificItem = () => {
  //   const keyToRemove = "wishList"; // Replace 'yourKey' with the key of the item you want to remove
  //   localStorage.removeItem(keyToRemove);
  //   console.log(`${keyToRemove} removed from localStorage`);
  // };

  return (
    <div
      style={{
        justifyContent: "center",
        fontFamily: "Droid Arabic Kufi, sans-serif",
      }}
    >
      <Switch>
        <Route exact path="/" component={Login} />
        <Route exact path="/main-page" component={MainPage} />
        <Route exact path="/login" component={Login} />
      </Switch>
    </div>
  );
};

export default App;
